import { combineDerivedThemeValues } from '@/services/widgetTheme/derivedValues';
import { BUTTON } from './button';
import { CHART } from './chart';
import { FORM } from './form';
import { SECTION } from './section';
export const ELEMENTS = combineDerivedThemeValues({
  button: BUTTON,
  chart: CHART,
  form: FORM,
  section: SECTION
});